var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSalary = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 16,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#48A1D9",
  d: "M8 10a.5.5 0 1 0 0-1 .5.5 0 0 0 0 1M0 3v4.2l.8.8h1.7V5.5h11V8h1.7l.8-.8V3z"
})), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
  fill: "#48A1D9",
  d: "M11.5 10.5c-.85 0-1.5.65-1.5 1.5H6c0-.85-.65-1.5-1.5-1.5V6h-1v7h9V6h-1z"
})), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
  fill: "#48A1D9",
  d: "M10 6.5c0-.2-.05-.35-.1-.5H6.15c-.05.15-.1.3-.1.5 0 .85.9 1.5 2 1.5S10 7.35 10 6.5"
})));
export default SvgSalary;